var map = {
	"./creditcard/mastercard.svg": 7702,
	"./creditcard/visa.svg": 6305,
	"./dashed_border.svg": 2466,
	"./icons.svg": 8680,
	"./logo.svg": 2539,
	"./logo_icon.svg": 8677,
	"./partners/knab-logo.svg": 1192,
	"./pay_methods/ach_transfer.png": 8107,
	"./pay_methods/afterpay.png": 5901,
	"./pay_methods/bancontact.png": 6908,
	"./pay_methods/bank_transfer.png": 121,
	"./pay_methods/blik.png": 1731,
	"./pay_methods/creditcard.png": 8740,
	"./pay_methods/ideal.png": 9702,
	"./pay_methods/ideal_qr.png": 2026,
	"./pay_methods/klarna.png": 8282,
	"./pay_methods/paypal.png": 7372,
	"./pay_methods/sepa.png": 96,
	"./pay_methods/square_icons/ach-transfer.png": 4228,
	"./pay_methods/square_icons/afterpay.png": 4908,
	"./pay_methods/square_icons/bancontact.png": 1097,
	"./pay_methods/square_icons/bank-transfer.png": 4652,
	"./pay_methods/square_icons/blik.png": 1414,
	"./pay_methods/square_icons/creditcard.png": 6725,
	"./pay_methods/square_icons/direct-debit.png": 6138,
	"./pay_methods/square_icons/ideal-qr.png": 5645,
	"./pay_methods/square_icons/ideal.png": 8893,
	"./pay_methods/square_icons/klarna-paynow.png": 5916,
	"./pay_methods/square_icons/paypal.png": 6809,
	"./pay_methods/square_icons/paypro.png": 1735,
	"./payment_page/discount_code.svg": 532,
	"./payment_page/testimonial_arrow.svg": 3668,
	"./payment_page/testimonial_star.svg": 7961,
	"./services/arrow.svg": 6964,
	"./services/blue-check.svg": 5526,
	"./services/green-check.svg": 6998,
	"./services/label.svg": 3917,
	"./socials/logo-whatsapp.svg": 6523,
	"./trackers/facebook-pixel.svg": 8536,
	"./trackers/google-tag-manager.svg": 7960,
	"./waves.png": 6747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2672;